import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeekForward10 = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		xmlns: "http://www.w3.org/2000/svg",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.28 24.35c1.14.46 2.35.69 3.57.67a.75.75 0 0 1 .02 1.5 10.76 10.76 0 1 1 0-21.52 10.92 10.92 0 0 1 10.72 8.88l1.13-1.74a.75.75 0 0 1 1.26.82l-2.32 3.56a.75.75 0 0 1-1.04.22l-3.56-2.32a.75.75 0 0 1 .82-1.26l2.32 1.51a9.42 9.42 0 0 0-9.34-8.17 9.26 9.26 0 0 0-3.58 17.85Z"
	}), /* @__PURE__ */ _jsx("path", {
		xmlns: "http://www.w3.org/2000/svg",
		d: "M17.78 19c1.36 0 2.22-1.17 2.22-3 0-1.88-.9-3-2.22-3-1.36 0-2.22 1.2-2.22 3 0 1.88.89 3 2.22 3Zm0-1.3c-.57 0-.86-.68-.86-1.7 0-1.15.35-1.7.86-1.7.57 0 .86.67.86 1.7 0 1.16-.34 1.7-.86 1.7ZM11.85 12.95a.65.65 0 0 0-.38.12l-.7.5a.65.65 0 1 0 .76 1.06l.17-.12V17.65h-.35a.65.65 0 1 0 0 1.3h2a.65.65 0 0 0 0-1.3H13V14.1a1.15 1.15 0 0 0-1.15-1.15Z"
	})]
});
export { SvgSeekForward10 as ReactComponent };
